import { useQuery } from "@tanstack/react-query";
import { __RolesNotPage } from "request/configuration/__Roles";

// Hook para obtener roles sin paginación
export const useRolesNotPage = (token, enabled = true) => {
  return useQuery({
    queryKey: ["rolesNotPage"],
    queryFn: async () => {
      const res = await __RolesNotPage(token);
      
      if (res.data.status?.code === 403) {
        throw new Error(res?.data?.status?.message);
      }
      
      // Retornar los datos tal como vienen del backend
      return res?.data?.status?.data || [];
    },
    enabled: enabled && !!token,
    staleTime: 5 * 60 * 1000, // 5 minutos (roles pueden cambiar más frecuentemente)
    gcTime: 5 * 60 * 1000, // 5 minutos
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: 1000
  });
};
